export const CARVAGO_TRANSACTION_WORKSPACE_URLS = {
  prod: 'https://carvago-b2b.omnetic.com/workspace',
  other: 'https://carvago-transaction.dev.omnetic.dev/workspace',
} as const;
